import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { isNewTagValue, newTagName } from '#/features/order-create'
import { useCreateTagApiV1TagsPost } from '#/shared/api/generated/shipment/theCargoShipment'
import { getApiErrorDetail } from '#/shared/lib/api/error-handler'
import { toast } from '#/shared/ui/sonner'

export function useSaveNewTags() {
  const { t } = useTranslation()
  const createTag = useCreateTagApiV1TagsPost()

  const save = useCallback(
    async (tagValues: readonly string[]): Promise<string[]> => {
      const resolved: string[] = []
      for (const value of tagValues) {
        if (!isNewTagValue(value)) {
          resolved.push(value)
          continue
        }
        const name = newTagName(value).trim()
        if (!name) continue
        try {
          const response = await createTag.mutateAsync({ data: { name } })
          resolved.push(response.data.id)
        } catch (error) {
          toast.error(
            getApiErrorDetail(error) ?? t('orderCreate.tag.saveError'),
          )
        }
      }
      return resolved
    },
    [createTag, t],
  )

  return { save, isSaving: createTag.isPending }
}
